import { configureStore } from '@reduxjs/toolkit';
import filesReducer from './slices/filesSlice';
import settignsReducer from './slices/settingsSlice';
import permissionsReducer from './slices/permissionsSlice';
import powerBiReportsReducer from './slices/powerBiReportsSlice';
import powerBiEmbedReducer from './slices/powerBiEmbedSlice';

export const store = configureStore({
  reducer: {
    files: filesReducer,
    settings: settignsReducer,
    permissions: permissionsReducer,
    powerBiReports: powerBiReportsReducer,
    powerBiEmbedData: powerBiEmbedReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
